import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import {
	Adg4SectionDivider,
	SECTION_DIVIDER_VARIATION,
} from '@/components/adg4/section-divider/src/section-divider';
import { Picture } from '@/components/wpl/image/src/image';
import { wacToken } from '@/libraries/design/foundations';

const quoteStyles = css({
	background: token('elevation.surface.sunken'),
	padding: '30px 20px 30px 100px',
	position: 'relative',
	marginBlockStart: '32px',

	// If nested selector isn't used, then property gets overriden
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.name': {
		fontWeight: 700,
	},
});

const quotePStyles = css({
	position: 'relative',
	margin: '0 0 1rem',
	fontFamily: wacToken('font.charlie.text'),
	fontSize: '14px',
	fontWeight: '400',
	lineHeight: '20px',
	textAlign: 'left',
});

const portraitStyles = css({
	position: 'absolute',
	width: '68px',
	insetInlineStart: '20px',
	insetBlockStart: '20px',
});

const nameStyles = css({
	position: 'relative',
	margin: 0,

	[media.above.md]: {
		marginBlockStart: '30px',
	},
});

const titleStyles = css({
	position: 'relative',
	margin: 0,
	textTransform: 'uppercase',
});

export type TestimonialQuoteProps = {
	quoteText: string;
	customerName: string;
	customerTitle: string;
	quoteColor: 'yellow' | 'purple' | 'lime' | 'blue' | 'none';
	colorAgainst?: string;
};

const quoteSrcMap = {
	yellow: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3ixqjd5540sdn251h25h55i82occ48sa.svg',
	purple: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0ho3162460jba51mgj0a16k3cpvy074s.svg',
	lime: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q6j1k002cmxpvr2145m8q3u70gfrm2qt.svg',
	blue: 'https://dam-cdn.atl.orangelogic.com/AssetLink/504175ycu5d01061dg4evte5l0m72pea.svg',
	none: '',
};

const TestimonialQuote = ({
	quoteText,
	customerName,
	customerTitle,
	quoteColor,
	colorAgainst,
}: TestimonialQuoteProps) => {
	const quoteImage = {
		src: quoteSrcMap[quoteColor],
		alt: customerTitle,
	};

	return (
		<>
			<div css={quoteStyles}>
				<p className="body-sm" css={quotePStyles}>
					{quoteText}
				</p>

				{quoteColor !== 'none' && (
					<div css={portraitStyles}>
						<Picture image={quoteImage} />
					</div>
				)}

				<p className="body-sm name" css={nameStyles}>
					{customerName}
				</p>
				<p className="fine-print" css={titleStyles}>
					{customerTitle}
				</p>
			</div>
			<Adg4SectionDivider
				variation={SECTION_DIVIDER_VARIATION.FLIP}
				desktopHeight={15}
				tabletHeight={15}
				mobileHeight={15}
				bgColor={token('elevation.surface.sunken')}
				colorAgainst={colorAgainst}
			/>
		</>
	);
};

export default TestimonialQuote;
